module.exports = __webpack_public_path__ + "img/image-rules-bonus.f19a40fb.svg";